import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';

import { PaymentAccountLedgerTab } from "./PaymentAccountLedgerTab";

const PaymentAccountDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'ledger';
  
  const tabs = [
    { label: 'Account Ledger',value: 'ledger',},
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
        <>
          <CustomTabPanel activeTab={activeTab} value="ledger">
          <PaymentAccountLedgerTab/>
          </CustomTabPanel>
        </>
     
    </>
  );
};

export default PaymentAccountDetailTab;